<form bind:this={formEl}>
  <noscript><p>This contact form requires JavaScript to function correctly.</p></noscript>

  {#if configRequired}
    <p>The contact form requires that you configure reCAPTCHA in the site configuration.</p>
  {/if}

  {#if emailTemplateIdRequired}
    <p>The contact form requires that you select an email template.</p>
  {/if}

  {#if !configRequired && !emailTemplateIdRequired}
    {#if emailSent}
      <p>Thank you, your email has been successfully sent.</p>
    {:else}
      <div class="cms-table cms-table--auto">
        {#each fields.items as item, i (item.id + formId)}
          <div
            class="cms-tr contact-form__row contact-form__type-{item.type} {item.required ? 'contact-form__required' : ''} {formErrs[i] ? 'contact-form__row--error' : ''} contact-form-row-{item.id || ''}"
            style={['hidden', 'hidden_blank'].includes(item.type) ? 'display: none;' : null}
          >
            <div class="cms-td contact-form__label">
              {#if item.type !== 'freetext'}
                <label for={formInputId(item)}>
                  {item.label}
                </label>
              {/if}
            </div>
            <div class="cms-td contact-form__value">
              {#if item.type === 'hidden'}
                <input
                  type="hidden"
                  id={formInputId(item)}
                  class={itemClasses(item)}
                  bind:value={item.placeholder}
                >
              {:else if item.type === 'hidden_blank'}
                <input
                  type="hidden"
                  id={formInputId(item)}
                  class={itemClasses(item)}
                >
              {:else if item.type === 'textarea'}
                <textarea
                  on:input={textAreaHandler(`contact-${formId}-${i}`)}
                  id={formInputId(item)}
                  class={itemClasses(item)}
                  placeholder={item.placeholder || ''}
                  bind:value={formVals[i]}
                />
              {:else if item.type === 'text'}
                <input
                  type="text"
                  id={formInputId(item)}
                  class={itemClasses(item)}
                  placeholder={item.placeholder || ''}
                  bind:value={formVals[i]}
                >
              {:else if item.type === 'freetext'}
                <div>
                  {@html item.placeholder}
                </div>
              {:else if item.type === 'attachment'}
                <input
                  type="file"
                  multiple
                  id={formInputId(item)}
                  class={itemClasses(item)}
                  placeholder={item.placeholder || ''}
                >
              {:else if item.type === 'datepicker'}
                <div class="contact-form__date-picker">
                  <Components.DatePicker
                    on:dateSelected={e => setDate(e, i)}
                    futureYears="true"
                    className="contact-form__date-picker-input {itemClasses(item)}"
                    date={formVals[i]}
                  />
                </div>
              {:else if item.type === 'email'}
                <input
                  type="email"
                  id={formInputId(item)}
                  class={itemClasses(item)}
                  placeholder={item.placeholder || ''}
                  bind:value={formVals[i]}
                >
              {:else if item.type === 'tel'}
                <input
                  type="tel"
                  id={formInputId(item)}
                  class={itemClasses(item)}
                  placeholder={item.placeholder || ''}
                  bind:value={formVals[i]}
                >
              {:else if item.type === 'number'}
                <input
                  type="number"
                  pattern="[0-9]*"
                  inputmode="numeric"
                  id={formInputId(item)}
                  class={itemClasses(item)}
                  placeholder={item.placeholder || ''}
                  bind:value={formVals[i]}
                >
              {:else if item.type === 'radio'}
                {#each item.options as el, j}
                  <div class="contact-radio__group">
                    <input
                      type="radio"
                      id="contact-radio-{i}-{j}"
                      value={el.value || el.label}
                      bind:group={formVals[i]}
                    >
                    <label for="contact-radio-{i}-{j}">{el.label}</label>
                  </div>
                {/each}
              {:else if item.type === 'checkbox'}
                {#each item.options as el, j}
                  <div class="contact-checkbox__group">
                    <input
                      type="checkbox"
                      id="contact-checkbox-{i}-{j}"
                      value={el.value || el.label}
                      bind:group={checkBoxVals} on:change={updateCheckboxes(i)}
                    >
                    <label
                      class="contact-checkbox__label"
                      for="contact-checkbox-{i}-{j}">{el.label}
                    </label>
                  </div>
                {/each}
              {:else if item.type === 'select'}
                <select
                  id={formInputId(item)}
                  class={itemClasses(item)}
                  bind:value={formVals[i]}
                >
                  <option value="">Please Select...</option>
                  {#each item.options as el, j}
                    <option value={el.value || el.label}>{el.label}</option>
                  {/each}
                </select>
              {:else if item.type === 'newsletter'}
                <div class="contact-checkbox-newsletter__group">
                  <input
                    type="checkbox"
                    id="contact-newsletter-checkbox-{i}"
                    value={item.value || item.label}
                    bind:group={checkBoxVals} on:change={updateCheckboxes(i)}
                  >
                  <div>{@html item.placeholder}</div>
                </div>
              {:else if item.type === 'allowLogging'}
                <div>
                  <input
                    type="checkbox"
                    id={formInputId(item)}
                    class={itemClasses(item)}
                    value={item.value || item.label}
                    bind:checked={formVals[i]}
                  >
                  <div>{@html item.placeholder}</div>
                </div>
              {:else if item.type === 'allowLoggingImplicit'}
                <div>
                  <div>
                    {@html item.placeholder}
                  </div>
                </div>
              {/if}
            </div>
          </div>
          {#if formErrs[i]}
            <span class="contact-form__error">{formErrs[i]}</span>
          {/if}
        {/each}

        <div
          class="cms-tr contact-form__row contact-form__row--submit
            {formErrRecaptcha ? 'contact-form__row--error' : ''}"
        >
          <div class="cms-td" />
          <div class="cms-td">
            <div class="contact-form__recaptcha">
              <div id={recaptchaPlaceholderId} class="contact-form__recaptcha-placeholder" />
              {#if formErrRecaptcha}
                <span class="contact-form__error contact-form__error--recaptcha">{ formErrRecaptcha }</span>
              {/if}
            </div>
            <button class="contact-form__submit-button" on:click={send}>{ fields.submitCaption }</button>
          </div>
        </div>
      </div>
    {/if}
  {/if}
</form>

<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};
  export const classNames = ['plugin__contact']
  export const Components = {
    load: [
      'core/extensions/date_picker/v1.0.0/DatePicker',
    ],
  }
  export async function serverInit (platform) {
    let emailTemplateType = null
    const name = 'Contact Plugin'
    const defaultEmailTemplate = {
      name: 'Contact Form Email',
      subject: `Contact from {{.hostname}}`,
      content: [
        `<table>`,
        `  {{range .rows}}`,
        `    <tr>`,
        `      <td>{{.label}}</td>`,
        `      <td>{{.value}}</td>`,
        `    </tr>`,
        `  {{end}}`,
        `  <tr>`,
        `    <td>URL</td>`,
        `    <td>{{.url}}</td>`,
        `  </tr>`,
        `</table>`,
      ].join('\n'),
    }

    try {
      emailTemplateType = await platform.api.cms.emailTemplateTypes.find(`emailTemplateType.name=${name}`)
      defaultEmailTemplate.emailTemplateTypeId = emailTemplateType.id

      const count = await platform.api.cms.emailTemplates.count(`emailTemplate.emailTemplateTypeId=${emailTemplateType.id}`)

      if (!count) {
        await platform.api.cms.emailTemplates.create(defaultEmailTemplate)
      }
    } catch (err) {}

    if (emailTemplateType) {
      return
    }

    try {
      emailTemplateType = await platform.api.cms.emailTemplateTypes.create({ name })
      defaultEmailTemplate.emailTemplateTypeId = emailTemplateType.id

      await platform.api.cms.emailTemplates.create(defaultEmailTemplate)
    } catch (err) {
      console.error(err)
    }
  }
</script>

<script>
  import { format } from 'date-fns'
  import { onMount, getContext } from 'svelte'

  export let fields = {}
  export let customToAddress

  $: if (!fields.items) {
    fields.items = []
  }

  $: {
    fields = fields
  }

  const platform = getContext('platform')
  let formId = ''
  let configRequired = true
  let emailTemplateIdRequired = true
  let recaptcha = ''
  let recaptchaPlaceholderId = ''
  let widgetId = ''
  let emailSent = false
  let campaignMonitorListKey = ''
  let mailchimpListKey = ''
  let adminEmailAddress = ''
  let formErrRecaptcha = ''
  let recaptchaSize
  let formVals = []
  let formErrs = []
  let checkBoxVals = []
  let textAreaEl
  let formEl

  function formInputId (item) {
    if (!item || typeof item.label !== 'string') {
      return ''
    }

    return `contact__${item.label.toLowerCase().trim().replace(/\s+/g, '-')}`
  }

  function updateCheckboxes (i) {
    checkBoxVals.length ? formVals[i] = checkBoxVals : formVals[i] = ''
  }

  function setDate (e, i) {
    const formatDate = format(new Date(e.detail), 'dd/MM/yyyy')
    formVals[i] = formatDate
  }
  // textarea auto height
  function textAreaHandler (element) {
    textAreaEl = document.querySelector(`#${element}`)
    textAreaEl.style.height = 'auto'
    textAreaEl.style.height = (textAreaEl.scrollHeight) + 'px'
  }

  onMount(async () => {
    await refreshFormVals()

    if (fields.emailTemplateId) {
      emailTemplateIdRequired = false
    }

    try {
      const config = await platform.api.cms.config.findAllAsObject()

      recaptchaPlaceholderId = 'contact-form-recaptcha--' + Math.floor(999999 * Math.random())

      if (config.recaptchaSize.value || config.recaptchaSiteKey.value) {
        configRequired = false
        recaptchaSize = config.recaptchaSize.value

        widgetId = await platform.api.cms.google.recaptcha.init(
          config.recaptchaSize.value,
          config.recaptchaSiteKey.value,
          recaptchaPlaceholderId,
          recaptchaCallback,
        )
      }

      adminEmailAddress = config.adminEmailAddress.value
      campaignMonitorListKey = config.campaignMonitorListKey?.value
      mailchimpListKey = config.mailchimpListKey?.value
    } catch (err) {
      console.error(err)
    }

    mailchimpListKey = fields.mailchimpListKey || mailchimpListKey
    campaignMonitorListKey = fields.campaignMonitorListKey || campaignMonitorListKey

    await refreshFormVals()
  })

  function itemClasses (item) {
    const classes = []

    if (item.id) {
      classes.push(`contact-plugin__item-${item.id.split('-').shift()}`)
    }

    return classes
  }

  async function refreshFormVals () {
    formVals = []

    for (let i = 0; i < fields.items.length; i++) {
      const item = fields.items[i]

      switch (item.type) {
        case 'checkbox':
          formVals[i] = []
          break
        default:
          formVals[i] = ''
      }
    }

    formId = Math.floor(999999 * Math.random())
  }

  async function send (e) {
    e.preventDefault()
    formErrs = []

    formVals.forEach((val, i) => {
      // validation rules
      switch (fields.items[i].type) {
        case 'number':
          if (val) {
            if (typeof val !== 'number') {
              formErrs[i] = `${fields.items[i].label} must be a number`
            }
          }
          break
      }
      if (!fields.items[i] || !fields.items[i].required) {
        return
      }

      const value = Array.isArray(val) ? val.join(', ') : val.toString()

      // case for required fields without input
      if (!value.trim() && fields.items[i].type !== 'attachment') {
        formErrs[i] = `${fields.items[i].label} is a required field`
      }

      const attachments = []

      const rowNodes = Array.from(formEl.querySelectorAll('.contact-form__row:not(.contact-form__row--submit)'))

      rowNodes.forEach(row => {
        const input = row.querySelector('input')

        if (input && input.type === 'file') {
          if (input.files) {
            for (let j = 0; j < input.files.length; ++j) {
              attachments.push(input.files[j].name)
            }
          }
        }
      })

      if (fields.items[i].type === 'attachment' && !attachments.length) {
        formErrs[i] = `${fields.items[i].label} must have an attachment selected.`
      }
    })

    if (recaptchaSize === 'checkbox' && !recaptcha) {
      formErrRecaptcha = 'This is a required field'
    } else {
      formErrRecaptcha = ''
    }

    if (formErrs.length || formErrRecaptcha) {
      return
    }

    if (recaptchaSize === 'invisible') {
      try {
        platform.api.cms.google.recaptcha.execute(widgetId)
      } catch (err) {
        console.error(err)
        platform.api.cms.google.recaptcha.reset(widgetId)
      }
    } else {
      await sendEmail()
    }

    recaptcha = ''
  }

  function recaptchaCallback (recaptchaValue) {
    recaptcha = recaptchaValue

    if (recaptchaSize === 'invisible') {
      sendEmail()
    }
  }

  async function newsletterSignup (emailAddress) {
    if (!emailAddress) {
      return
    }

    try {
      // if (mailchimpListKey) {
      //   await platform.api.cms.mailchimp.addSubscriberToList({
      //     listKey: mailchimpListKey,
      //     emailAddress: emailAddress,
      //   })
      // }

      if (campaignMonitorListKey) {
        await platform.api.cms.campaignMonitor.addSubscriberToList(campaignMonitorListKey, {
          email: emailAddress,
          name: '',
        })
      }
    } catch (err) {
      console.error(err)
    }
  }

  async function sendEmail () {
    platform.api.core.loading.show()

    try {
      const { successRedirectUrl, toAddress, items, storeInCRM } = fields
      const crmData = storeInCRM ? {} : null
      let replyTo = ''
      let newsletterRequest = false
      let allowLogging = false
      const files = []
      const attachments = []

      const rows = []
      const rowNodes = Array.from(formEl.querySelectorAll('.contact-form__row:not(.contact-form__row--submit)'))

      rowNodes.forEach((row, i) => {
        const input = row.querySelector('input')

        if (input && input.type === 'file') {
          if (input.files) {
            for (let j = 0; j < input.files.length; ++j) {
              files.push(input.files[j])
              attachments.push(input.files[j].name)
            }
          }

          return
        }

        const hidden = row.querySelector('input[type="hidden"]')
        const custom = row.querySelector('.contact-form__custom')
        const label = row.querySelector('.contact-form__label').innerText
        let value = ''

        if (hidden) {
          value = hidden.value
        } else if (custom) {
          value = custom.value
        } else if (Array.isArray(formVals[i])) {
          value = formVals[i].join(', ')
        } else {
          value = formVals[i] || value
        }

        value = String(value)

        if (crmData) {
          crmData[label] = value
        }

        rows.push({
          label,
          value,
        })
      })

      for (const [key, value] of platform.router.params.entries()) {
        if (!key.startsWith('ref.')) {
          continue
        }

        const label = key.split('.').slice(1).join('.')

        if (label && value) {
          rows.push({
            label,
            value,
          })
        }
      }

      let tel = ''

      for (let i = 0; i < items.length; ++i) {
        switch (items[i].type) {
          case 'email':
            if (!replyTo) {
              replyTo = formVals[i]
            }
            break
          case 'tel':
            if (!tel) {
              tel = formVals[i]
            }
            break
          case 'newsletter':
            if (!newsletterRequest) {
              newsletterRequest = formVals[i]
            }
            break
          case 'allowLogging':
            if (!allowLogging && !!formVals[i]) {
              allowLogging = !!formVals[i]
            }
            break
          case 'allowLoggingImplicit':
            allowLogging = true
            break
        }
      }

      const template = {
        id: fields.emailTemplateId,
        vars: {
          url: platform.router.absolute,
          params: platform.router.paramsAsObject(),
          rows,
          allowLogging: !!allowLogging,
          newsletterRequest: !!newsletterRequest,
        },
      }

      if (adminEmailAddress) {
        for (let i = 0; i < fields.items.length; ++i) {
          if (fields.items[i].required && formVals[i] === '') {
            await platform.api.cms.emails.send({
              allowLogging,
              recaptcha,
              url: platform.router.absolute,
              to: adminEmailAddress,
              replyTo: replyTo || null,
              template,
              crmData,
            })

            window.alert('The enquiry details you submitted included a blank value in a required field. Your email has been sent to an admin.')
            platform.api.cms.google.recaptcha.reset(widgetId)
            recaptcha = ''

            platform.api.core.loading.hide()

            return
          }
        }
      }
      // allow separation with commas or semicolons
      if (customToAddress) {
        if (customToAddress.indexOf(',') > -1) {
          customToAddress = customToAddress.split(',')
        } else if (customToAddress.indexOf(';') > -1) {
          customToAddress = customToAddress.split(';')
        }
      }

      await platform.api.cms.emails.send({
        allowLogging,
        recaptcha,
        url: platform.router.absolute,
        to: customToAddress || toAddress || null,
        replyTo: replyTo || null,
        template,
        attachments: attachments || null,
        crmData,
      }, files)

      if (newsletterRequest) {
        await newsletterSignup(replyTo || null)
      }

      emailSent = true

      const dataLayer = window.dataLayer

      if (dataLayer) {
        dataLayer.push({
          event: 'form_submit',
          email: replyTo,
          telephone: tel,
        })
      }

      if (successRedirectUrl) {
        platform.api.core.loading.hide()

        platform.router.push(successRedirectUrl)

        return
      }
    } catch (err) {
      if (err.data.status === 413) {
        window.alert('The files you tried to upload are too large (max size 50MB).')
      }
      console.error(err)
    }

    platform.api.cms.google.recaptcha.reset(widgetId)

    recaptcha = ''

    platform.api.core.loading.hide()
  }
</script>

<style>
  .contact-form__required label::after {
    content: ' *';
  }
  .contact-checkbox__group label::after, .contact-radio__group label::after {
    content: '';
  }

  .contact-form__error {
    color: red;
  }

  textarea::-webkit-scrollbar {
    display: none;
  }
  .contact-radio__group, .contact-checkbox__group {
    display:flex;
    align-items:center;
  }
  .contact-radio__group, .contact-checkbox__group input {
    margin-right:8px;
  }
  .contact-checkbox__group input {
    width:max-content;
  }
  .contact-radio__group input {
    width:13px;
    height:13px;
    margin-bottom:5px;
  }

</style>
